<template>
	<transition enter-active-class="animated fadeIn faster"
	            leave-active-class="animated fadeOut faster">
		<div class="container-fluid flex-column position-absolute justify-content-center h-100 main"
		     v-show="editOperatorPropsShow">
			<div class="container bg-light col-lg-8 col-md-8 col-xl-7 col-sm-8 p-5 popup">
				<div class="container align-items-start justify-content-between text-center">
					<label for="editname"
					       class="label mb-1">Имя на серверe</label>
					<input class="input"
					       type="text"
					       id="editname"
					       autocomplete="off"
					       v-model="editOperatorPropsOperator.name"></div>
				<div class="container  align-items-start justify-content-between text-center">
					<label for="editdisplay_name"
					       class="label mb-1 mt-3">Отображаемое имя</label>
					<input class="input"
					       type="text"
					       id="editdisplay_name"
					       autocomplete="off"
					       v-model="editOperatorPropsOperator.display_name"></div>
				<div class="container  align-items-start justify-content-between text-center">
					<label for="editurl"
					       class="label mb-1 mt-3">URL</label>
					<input class="input"
					       type="text"
					       id="editurl"
					       autocomplete="off"
					       v-model="editOperatorPropsOperator.api_url"></div>
				<div class="container justify-content-around cont mt-4 mb-3 ">
					<button class="btn btn-outline-success button" @click="updateOperatorFun">изменить</button>
					<button class="btn btn-outline-dark button" @click="cancel">отменить</button>
				</div>
				<transition enter-active-class="animated fadeInUp"
				            leave-active-class="animated fadeOutDown">
					<p class="text-danger mb-0 pb-0 position-absolute err_handler" v-if="correct">{{ messageError }}</p>
				</transition>
			</div>
		</div>
	</transition>
</template>
<script>
	import { performRequest } from "../script/ws/wsclient";

	export default {
		name:    "EditOperator",
		data() {
			return {
				addedReg: true,
				correct:  false,
				messageError: '',
				old_name: ''
			};
		},
		props:   {
			editOperatorPropsShow: Boolean,
			editOperatorPropsOperator: Object,
			editOperatorPropsOperatorOld: String
		},
		methods: {
			cancel() {
				this.$emit("hiddenNewOper", { show: false, getOper: true });
			},
			errorHandler(value) {
				this.messageError = value;
				if (!this.correct) {
					this.correct = true;
					setTimeout(() => {
						this.correct = false;
					}, 2500);
				}
			},
			updateOperatorFun() {
				if (document.querySelector("#editname").value !== "" &&
					document.querySelector("#editdisplay_name").value !== "" &&
					document.querySelector("#editurl").value !== "") {
					let data = {
						name:         document.querySelector("#editname").value.trim(),
						display_name: document.querySelector("#editdisplay_name").value.trim(),
						api_url: document.querySelector("#editurl").value,
						old_name: this.editOperatorPropsOperatorOld
					};
					performRequest(
						{
							section: "tvcontent.operator",
							name:    "updateOperator"
						},
						data,
						a => {
							if (a.code === 200) {
								this.$emit("hiddenNewOper", {show:false, getOper: true});
							}
							else if (a.code === 400) {
								this.errorHandler("введены не корректные данные");
							}
							else if (a.code === 500) {
								this.errorHandler("ошибка на сервере");
							}
							else {
								console.log("ошибка =(((");
							}
						});
				} else {
					this.errorHandler("все поля должны быть заполнены");
				}
			},
		}
	};
</script>
<style scoped lang="scss">
	@import "~bootstrap/scss/bootstrap";
	.btn {
		padding: 0 1rem;
		height: 3rem;
		min-width: 5rem;
		margin: 0;
	}
	.list {
		border-top: 1px solid rgba(44, 62, 80, 0.47);
		transition: background-color .3s;
		&:hover {
			background-color: rgba(128, 140, 166, 0.33);
		}
		&:last-child {
			border-bottom: 1px solid rgba(44, 62, 80, 0.47);
		}
		
	}
	.label {
		width: 200px;
	}
	.main {
		background-color: rgba(130, 130, 130, 0.27);
		flex-direction: column;
	}
	.input {
		width: 70%;
		height: 1.8rem;
		outline: none;
		border: 1px solid gray;
		border-radius: 3px;
		transition: all .3s;
		padding-left: 5px;
		&:focus {
			border: 1px solid #acafff;
			box-shadow: 0 0 7px #acafff;
		}
	}
	.popup {
		top: 50%;
		transform: translateY(-50%);
	}
	.err_handler {
		bottom: 1.5rem;
		font-size: 1.1rem;
		left: 3.8rem;
	}
	.cont {
		text-align: center;
	}
	.button {
		max-height: 2rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/EditOperator.vue